module.exports = __webpack_public_path__ + "files/0173a5b894f717343d8ff2b4c0daeeed.png";